import React from 'react'
import { useQuery } from 'urql';
import { List, Button, Spin, Result } from 'antd';

const PokemonsActionQuery = `
  query {
    getPokemons {
        next
        previous
        results
        count
    }
  }
`;

function PokemonListAPI() {

    const [{ data, fetching, error }] = useQuery({
        query: PokemonsActionQuery,
    });

    if (fetching) return <Spin size="large" />;

    if (error) return <Result
        status="error"
        title="Fetcing Data From https://pokeapi.co through Hasura Failed"
        subTitle="Please check you network settings"
        extra={[
            <Button type="primary" key="console">
                Try Again
            </Button>,
        ]}>
    </Result>;

    return (
        <List
            itemLayout="horizontal"
            dataSource={data.getPokemons.results}
            renderItem={pokemon => (
                <List.Item>
                    <List.Item.Meta
                        title={pokemon.name}
                    />
                </List.Item>
            )}
        />
    )
}

export default PokemonListAPI
